export default {
  abi: [
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "name_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol_",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "decimals",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "burnFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "mint",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  bytecode: '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'
}



// WEBPACK FOOTER //
// ./src/erc20/ERC20Multi.js